import { languages } from '@i18n';

export const localesByCulture = new Map<string, string>(
  languages.map(({ code, locale }) => [code, locale] as const),
);

const caesarDecode = (str: string, shift: number): string => {
  if (!str) return '';
  return str
    .split('')
    .map((char) => {
      const code = char.charCodeAt(0);
      if (code >= 32 && code <= 126) {
        const base = 32;
        const span = 126 - 32;
        return String.fromCharCode(
          ((code - base - shift + span) % span) + base,
        );
      }
      return char;
    })
    .join('');
};

const contactPhoneEncoded = import.meta.env.VITE_CONTACT_PHONE_ENCODED;
const contactMailEncoded = import.meta.env.VITE_CONTACT_MAIL_ENCODED;

if (!contactPhoneEncoded) console.warn('VITE_CONTACT_PHONE_ENCODED is not set');
if (!contactMailEncoded) console.warn('VITE_CONTACT_MAIL_ENCODED is not set');

// Plain spambot protection to avoid reading the email directly from the code.
export const contactDetails = {
  facebookPage: 'https://www.facebook.com/profile.php?id=100090665017377',
  twitterPage: '',
  linkedinPage: '',
  instagramPage: '',
  phone: caesarDecode(contactPhoneEncoded, 12),
  mail: caesarDecode(contactMailEncoded, 13),
};

export const headerStickyPoint = 445;

// kitchens, living rooms, balconies, storage
export const propertyDetailsAmenityIds = [281, 381];
// condition, view, direction, floor type, heating type, fuel type
export const propertyMainAmenityIds = [302, 303, 304, 290, 293, 294];
